import React, { Component } from "react";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      render: false
    };
    this.cf = null;
  }

  componentDidMount() {
    setTimeout(
      function() {
        //Start the timer
        this.setState({ render: true }); //After 1 second, set render to true
      }.bind(this),
      9000
    );
    // add Conversational Form info
    this.cf = window.cf.ConversationalForm.startTheConversation({
      formEl: this.refs.form,
      context: document.getElementById("cf-context"),
      robotImage:
        "https://softagram.com/wp-content/uploads/2018/12/apple-icon.png",
      userImage: "https://softagram.com/wp-content/uploads/2018/12/user.jpeg",
      userInterfaceOptions: {
        controlElementsInAnimationDelay: 1000,
        robot: {
          robotResponseTime: 1000,
          chainedResponseTime: 1000
        },
        user: {
          showThinking: false,
          showThumb: false
        }
      }
    });
  }

  componentDidUpdate() {
    const client_id = "bb3a874e3dcc54cdee53";
    if (this.state.render) {
      window.ConversationalForm.addUserChatResponse(
        `<a href='https://github.com/login/oauth/authorize?client_id=${client_id}&scope=user:email' class='login-btn'>
          <img src='https://softagram.com/wp-content/uploads/2018/12/github-icon.png' class='login-icon'/>
          <span id='btn-title'>Login with GitHub</span>
        </a>`
      );
    }
  }

  render() {
    return (
      <div id="cf-context" className="login-form">
        <div id="form" className="form" ref="form">
          <input cf-questions="Hi, It's Softagram here.&&I help you to analyze any open source pull request in 2 steps:&&First: Authenticate (I add your GitHub id to the report that look like this <a id='link' href='https://github.com/softagram/koin/pull/4#issuecomment-460940042'>https://github.com/softagram/koin/pull/4#issuecomment-460940042</a>)&&Second: paste the pullrequest URL!&&Let me first authorize you with GitHub.&&Before login, you should read and understand the <a id='link' href='https://softagram.com/wp-content/uploads/2018/03/IT2018_EHK_English.pdf' target='__blank'>terms and conditions for the processing of personal data</a>" />
          <button type="submit">Submit</button>
        </div>
      </div>
    );
  }
}

export default Login;
